import React from 'react';
import Navbar from './marketing-components/Navbar';
import Hero from './marketing-components/Hero';
import CredibilityStrip from './marketing-components/CredibilityStrip';
import ProblemSection from './marketing-components/ProblemSection';
import PlatformExplanation from './marketing-components/PlatformExplanation';
import HowItWorks from './marketing-components/HowItWorks';
import ProductPreview from './marketing-components/ProductPreview';
import Benefits from './marketing-components/Benefits';
import ReputationFirewall from './marketing-components/ReputationFirewall';
import Documentation from './marketing-components/Documentation';
import Pricing from './marketing-components/Pricing';
import Company from './marketing-components/Company';
import FinalCTA from './marketing-components/FinalCTA';
import Footer from './marketing-components/Footer';
import './App.css';

function App() {
  return (
    <div className="marketing-app">
      <Navbar />
      <main>
        <Hero />
        <CredibilityStrip />
        <ProblemSection />
        <PlatformExplanation />
        <HowItWorks />
        <ProductPreview />
        <Benefits />
        <ReputationFirewall />
        <Documentation />
        <Pricing />
        <Company />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
